export default "__VITE_ASSET__eeFQNFe6__"